import { Panel, Step } from 'utils/enumerations';

export const diggingPermitPanelOrderList = [
  Panel.Case,
  Panel.Questioneer,
  Panel.InvoiceAddress,
  Panel.EntrepreneurAndSupervisor,
  Panel.DateAndTimePeriod,
  Panel.Extent,
  Panel.Purpose,
  Panel.WorkPerformedIn,
  Panel.WorkMethod,
  Panel.AdditionalInformation,
  Panel.ConnectedCases
];

export const taPlanPanelOrderList = [
  Panel.CreateTAPlan,
  Panel.Questioneer,
  Panel.InvoiceAddress,
  Panel.WorkType,
  Panel.DateAndTimePeriod,
  Panel.Extent,
  Panel.MarkingManager,
  Panel.InspectionManager,
  Panel.AdditionalInformation
];

export const leaseholdPanelOrderList = [
  Panel.CreateLeasehold,
  Panel.Questioneer,
  Panel.InvoiceAddress,
  Panel.DateAndTimePeriod,
  Panel.Extent,
  Panel.AdditionalInformation
];

export const diggingPermitStepPanels = [
  {
    step: Step.Basic,
    panels: [
      Panel.Case,
      Panel.Questioneer,
      Panel.InvoiceAddress,
      Panel.DateAndTimePeriod,
      Panel.EntrepreneurAndSupervisor
    ]
  },
  { step: Step.Map, panels: [] },
  { step: Step.Errand, panels: [Panel.Purpose, Panel.WorkPerformedIn, Panel.WorkMethod] },
  { step: Step.Finish, panels: [Panel.AdditionalInformation, Panel.ConnectedCases] }
];

export const taPlanStepPanels = [
  {
    step: Step.Basic,
    panels: [Panel.CreateTAPlan, Panel.Questioneer, Panel.InvoiceAddress, Panel.WorkType, Panel.DateAndTimePeriod]
  },
  { step: Step.Map, panels: [] },
  { step: Step.Managers, panels: [Panel.MarkingManager, Panel.InspectionManager] },
  { step: Step.Finish, panels: [Panel.AdditionalInformation] }
];

export const leaseholdStepPanels = [
  {
    step: Step.Basic,
    panels: [Panel.CreateLeasehold, Panel.Questioneer, Panel.InvoiceAddress, Panel.DateAndTimePeriod]
  },
  { step: Step.Map, panels: [] },
  { step: Step.Finish, panels: [Panel.AdditionalInformation] }
];

const hasValue = value => {
  if (value === undefined || value === null || value === '') {
    return false;
  }
  if (Array.isArray(value) && value.length === 0) {
    return false;
  }
  return true;
};

export function panelHasAnyValue(valueObject, panelName, keyPanels, propKey) {
  if (!hasValue(valueObject)) {
    return false;
  }

  if (valueObject.constructor !== Object) {
    const indexInPanel = keyPanels
      .find(panelwithKey => panelwithKey.panelName === panelName)
      ?.keys.findIndex(key => key === propKey);
    if (indexInPanel > -1) {
      return true;
    }
    return false;
  } else if (valueObject.constructor === Object) {
    for (const prop in valueObject) {
      const foundValue = panelHasAnyValue(valueObject[prop], panelName, keyPanels, prop);
      if (foundValue) {
        return true;
      }
    }
  }
  return false;
}

export const getPreviewPanel = panel => {
  switch (panel) {
    case Panel.Purpose:
    case Panel.WorkPerformedIn:
    case Panel.WorkMethod:
      return Panel.Purpose;
    default:
      return panel;
  }
};

export const dpPanelWithKeys = [
  {
    panelName: Panel.Case,
    keys: ['caseName', 'location', 'ledningskollenId']
  },
  {
    panelName: Panel.Questioneer,
    keys: [
      'organisationName',
      'organisationNumber',
      'billingAddress',
      'billingPostalCode',
      'applicantName',
      'email',
      'phone',
      'mobilePhoneNumber'
    ]
  },
  {
    panelName: Panel.InvoiceAddress,
    keys: [
      'alternativeBillingAddress',
      'alternativeBillingPostalCode',
      'alternativeBillingPostalCity',
      'invoiceMarking'
    ]
  },
  {
    panelName: Panel.EntrepreneurAndSupervisor,
    keys: [
      'entrepreneurName',
      'entrepreneurOrganisationNumber',
      'entrepreneurAddress',
      'entrepreneurPostalCode',
      'supervisorName',
      'supervisorPhoneNumber',
      'supervisorMobilePhoneNumber',
      'supervisorEmail'
    ]
  },
  {
    panelName: Panel.DateAndTimePeriod,
    keys: ['dateFrom', 'dateTo', 'prolongedTo']
  },
  {
    panelName: Panel.Purpose,
    keys: ['purpose', 'workTypes']
  },
  {
    panelName: Panel.WorkPerformedIn,
    keys: ['executedIns']
  },
  {
    panelName: Panel.WorkMethod,
    keys: ['depth', 'workMethod']
  },
  {
    panelName: Panel.AdditionalInformation,
    keys: ['additionalInformation', 'attachments']
  }
];

export const lhPanelWithKeys = [
  {
    panelName: Panel.CreateLeasehold,
    keys: ['purpose', 'location']
  },
  {
    panelName: Panel.Questioneer,
    keys: [
      'organisationName',
      'organisationNumber',
      'billingAddress',
      'billingPostalCode',
      'applicantName',
      'email',
      'phone',
      'mobilePhoneNumber'
    ]
  },
  {
    panelName: Panel.InvoiceAddress,
    keys: [
      'alternativeBillingAddress',
      'alternativeBillingPostalCode',
      'alternativeBillingPostalCity',
      'invoiceMarking'
    ]
  },
  {
    panelName: Panel.DateAndTimePeriod,
    keys: ['dateFrom', 'dateTo', 'prolongedTo']
  },
  {
    panelName: Panel.AdditionalInformation,
    keys: ['additionalInformation', 'attachments']
  }
];

export const tapPanelWithKeys = [
  {
    panelName: Panel.CreateTAPlan,
    keys: ['caseName', 'location']
  },
  {
    panelName: Panel.Questioneer,
    keys: [
      'organisationName',
      'organisationNumber',
      'billingAddress',
      'billingPostalCode',
      'applicantName',
      'email',
      'phone',
      'mobilePhoneNumber'
    ]
  },
  {
    panelName: Panel.InvoiceAddress,
    keys: [
      'alternativeBillingAddress',
      'alternativeBillingPostalCode',
      'alternativeBillingPostalCity',
      'invoiceMarking'
    ]
  },
  {
    panelName: Panel.WorkType,
    keys: ['workType']
  },
  {
    panelName: Panel.DateAndTimePeriod,
    keys: ['dateFrom', 'dateTo', 'prolongedTo']
  },
  {
    panelName: Panel.MarkingManager,
    keys: ['markingManager', 'markingManagerMobilePhoneNumber']
  },
  {
    panelName: Panel.InspectionManager,
    keys: ['inspectionManager', 'inspectionManagerMobilePhoneNumber']
  },
  {
    panelName: Panel.AdditionalInformation,
    keys: ['additionalInformation', 'attachments']
  }
];
